import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/api`;
const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

const AlerteService = {

  getApiUrl: (role) => {
    return role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
  },

  _headers: (token) => ({
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  }),

  getAlertes: async (token, role = "admin") => {
    const api = AlerteService.getApiUrl(role);
    const response = await axios.get(`${api}/alertes`, {
      headers: AlerteService._headers(token),
    });
    return response.data;
  },

  // ── Actions depuis les Alertes ─────────────────────────────────────────────

  
  updateFromAlerte: async (token, role, payload) => {
    const api = AlerteService.getApiUrl(role);
    const response = await axios.post(`${api}/actions/update-from-alerte`, payload, {
      headers: AlerteService._headers(token),
    });
    return response.data;
  },

  resilier: async (token, role = "admin", payload) => {
    const api = AlerteService.getApiUrl(role);
    const response = await axios.post(`${api}/actions/resilier`, payload, {
      headers: AlerteService._headers(token),
    });
    return response.data;
  },

  renouvelerPreview: async (token, role = "admin", type, id) => {
    const api = AlerteService.getApiUrl(role);
    const response = await axios.get(`${api}/actions/renouveler/preview`, {
      params: { type, id },
      headers: AlerteService._headers(token),
    });
    return response.data;
  },

  renouveler: async (token, role = "admin", payload) => {
    const api = AlerteService.getApiUrl(role);
    const response = await axios.post(`${api}/actions/renouveler`, payload, {
      headers: AlerteService._headers(token),
    });
    return response.data;
  },
};

export default AlerteService;